(() => {
  // footer-work/glyph-helpers.ts
  var clamp = (v, lo, hi) => v < lo ? lo : v > hi ? hi : v;
  var S = 19;
  var B = 17;
  var f = (n) => String(Math.round(n * 100) / 100);
  var rect = (x, y, w, h) => "M" + f(x) + " " + f(y) + "H" + f(x + w) + "V" + f(y + h) + "H" + f(x) + "Z";
  var slant = (x1, y1, x2, y2, t) => "M" + f(x1) + " " + f(y1) + "H" + f(x1 + t) + "L" + f(x2 + t) + " " + f(y2) + "H" + f(x2) + "Z";
  var at = (cx, cy, rx, ry, deg) => {
    const a = deg * Math.PI / 180;
    return f(cx + rx * Math.cos(a)) + " " + f(cy + ry * Math.sin(a));
  };
  var band = (cx, cy, rx, ry, tx, ty, a0, a1) => {
    const large = Math.abs(a1 - a0) > 180 ? 1 : 0;
    const cw = a1 > a0 ? 1 : 0;
    const irx = rx - tx;
    const iry = ry - ty;
    return "M" + at(cx, cy, rx, ry, a0) + "A" + f(rx) + " " + f(ry) + " 0 " + large + " " + cw + " " + at(cx, cy, rx, ry, a1) + "L" + at(cx, cy, irx, iry, a1) + "A" + f(irx) + " " + f(iry) + " 0 " + large + " " + (1 - cw) + " " + at(cx, cy, irx, iry, a0) + "Z";
  };
  var ring = (cx, cy, rx, ry, tx, ty) => {
    const e = (r1, r2) => "M" + f(cx - r1) + " " + f(cy) + "A" + f(r1) + " " + f(r2) + " 0 1 1 " + f(cx + r1) + " " + f(cy) + "A" + f(r1) + " " + f(r2) + " 0 1 1 " + f(cx - r1) + " " + f(cy) + "Z";
    return e(rx, ry) + e(rx - tx, ry - ty);
  };
  var bowl = (x, y, w, h, t, tb) => {
    const ry = h / 2;
    const rx = Math.min(w - t, ry * 0.95);
    const sx = x + w - rx;
    return "M" + f(x) + " " + f(y) + "H" + f(sx) + "A" + f(rx) + " " + f(ry) + " 0 0 1 " + f(sx) + " " + f(y + h) + "H" + f(x) + "ZM" + f(x + t) + " " + f(y + tb) + "H" + f(sx) + "A" + f(rx - t) + " " + f(ry - tb) + " 0 0 1 " + f(sx) + " " + f(y + h - tb) + "H" + f(x + t) + "Z";
  };
  var GLYPHS = {
    A: { w: 96, d: [slant(37, 0, 0, 100, 23), slant(37, 0, 73, 100, 23), rect(18, 60, 60, 16)] },
    B: { w: 84, d: [rect(0, 0, S, 100), bowl(0, 0, 78, 52, S, B), bowl(0, 52 - B, 84, 100 - 52 + B, S, B)] },
    C: { w: 90, d: [band(45, 50, 45, 50, S + 2, B, -40, -320)] },
    D: { w: 90, d: [rect(0, 0, S + 1, 100), bowl(0, 0, 90, 100, S + 2, B)] },
    E: { w: 72, d: [rect(0, 0, S, 100), rect(0, 0, 72, B), rect(0, 41.5, 64, B), rect(0, 100 - B, 72, B)] },
    F: { w: 70, d: [rect(0, 0, S, 100), rect(0, 0, 70, B), rect(0, 43, 62, B)] },
    G: { w: 94, d: [band(47, 50, 47, 50, S + 2, B, -38, -360), rect(48, 46, 46, B)] },
    H: { w: 86, d: [rect(0, 0, S, 100), rect(86 - S, 0, S, 100), rect(0, 42, 86, B)] },
    I: { w: S + 2, d: [rect(0, 0, S + 2, 100)] },
    J: { w: 72, d: [rect(72 - S, 0, S, 64), band(36, 62, 36, 38, S, B, 0, 180)] },
    K: { w: 86, d: [rect(0, 0, S, 100), slant(62, 0, 10, 62, 24), slant(30, 42, 62, 100, 24)] },
    L: { w: 68, d: [rect(0, 0, S, 100), rect(0, 100 - B, 68, B)] },
    M: { w: 112, d: [rect(0, 0, S + 3, 100), slant(0, 0, 46, 100, 9), slant(68, 0, 40, 100, 22), rect(112 - S - 3, 0, S + 3, 100)] },
    N: { w: 88, d: [rect(0, 0, S, 100), rect(88 - S, 0, S, 100), slant(0, 0, 63, 100, 25)] },
    O: { w: 100, d: [ring(50, 50, 50, 50, S + 2, B)] },
    P: { w: 80, d: [rect(0, 0, S, 100), bowl(0, 0, 80, 60, S, B)] },
    Q: { w: 100, d: [ring(50, 50, 50, 50, S + 2, B), slant(50, 62, 78, 100, 22)] },
    R: { w: 84, d: [rect(0, 0, S, 100), bowl(0, 0, 82, 58, S, B), slant(34, 50, 62, 100, 22)] },
    // Two bands that meet on the spine: r = (CAP + B) / 4 makes it exactly B thick.
    S: { w: 80, d: [band(40, 29.25, 40, 29.25, S, B, -22, -273), band(40, 70.75, 40, 29.25, S, B, -93, 158)] },
    T: { w: 82, d: [rect(0, 0, 82, B), rect(41 - S / 2 - 1, 0, S + 2, 100)] },
    // Stems run 2 past the band so the joins never show a hairline.
    U: { w: 86, d: [rect(0, 0, S, 60), rect(86 - S, 0, S, 60), band(43, 58, 43, 42, S, B, 0, 180)] },
    V: { w: 94, d: [slant(0, 0, 36, 100, 22), slant(72, 0, 36, 100, 22)] },
    W: { w: 132, d: [slant(0, 0, 26, 100, 20), slant(56, 0, 26, 100, 20), slant(56, 0, 86, 100, 20), slant(112, 0, 86, 100, 20)] },
    X: { w: 92, d: [slant(0, 0, 68, 100, 24), slant(68, 0, 0, 100, 24)] },
    Y: { w: 92, d: [slant(0, 0, 35, 56, 22), slant(70, 0, 35, 56, 22), rect(35, 50, 22, 50)] },
    Z: { w: 80, d: [rect(0, 0, 80, B), rect(0, 100 - B, 80, B), slant(56, B - 1, 0, 100 - B + 1, 24)] }
  };
  var approach = (from, to, k, dt) => to + (from - to) * Math.pow(1 - clamp(k, 0, 1), clamp(dt, 0, 0.1) * 60);

  // footer-work/motion.ts
  (() => {
    const key = "__spotItShutterFooter";
    if (window[key]) {
      window[key].scan(document);
      return;
    }
    const controllers = /* @__PURE__ */ new Map();
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    function init(root) {
      if (controllers.has(root)) return;
      const svg = root.querySelector("[data-sgf-svg]");
      const letterO = root.querySelector("[data-sgf-o]");
      const tilt = letterO == null ? void 0 : letterO.querySelector("[data-sgf-o-tilt]");
      if (!svg || !letterO || !tilt) return;
      const cleanup = [];
      let destroyed = false, seen = false, visible = false, raf = 0, last = 0, spins = 0;
      let current = { x: 0, y: 0 };
      const pointer = { x: 0, y: 0, inside: false };
      const still = () => mq.matches || root.dataset.animate === "false";
      const listen = (el, event, fn) => {
        el.addEventListener(event, fn);
        cleanup.push(() => el.removeEventListener(event, fn));
      };
      const rounded = (n) => String(Math.round(n * 1e3) / 1e3);
      const paint = () => {
        const { x, y } = current;
        tilt.setAttribute("transform", `translate(50 50) rotate(${rounded(x * 7)}) skewX(${rounded(-y * 5)}) scale(${rounded(1 - Math.abs(x) * 0.055)} ${rounded(1 - Math.abs(y) * 0.025)}) translate(-50 -50)`);
      };
      const stop = () => {
        cancelAnimationFrame(raf);
        raf = 0;
      };
      const tick = (now) => {
        raf = 0;
        if (destroyed || still() || !visible || document.hidden) return;
        const dt = Math.min(0.1, (now - last) / 1e3);
        last = now;
        const tx = pointer.inside ? pointer.x : 0;
        const ty = pointer.inside ? pointer.y : 0;
        current = { x: approach(current.x, tx, 0.1, dt), y: approach(current.y, ty, 0.1, dt) };
        paint();
        if (Math.abs(current.x - tx) + Math.abs(current.y - ty) > 1e-3) raf = requestAnimationFrame(tick);
        else {
          current = { x: tx, y: ty };
          paint();
        }
      };
      const wake = () => {
        if (!raf && !still() && visible && !document.hidden) {
          last = performance.now();
          raf = requestAnimationFrame(tick);
        }
      };
      const pointerMove = (event) => {
        const e = event;
        if (e.pointerType === "touch") return;
        const matrix = svg.getScreenCTM();
        if (!matrix) return;
        const point = svg.createSVGPoint();
        point.x = e.clientX;
        point.y = e.clientY;
        const local = point.matrixTransform(matrix.inverse());
        pointer.x = clamp((local.x - Number(letterO.dataset.sgfX || 0) - 50) / 160, -1, 1);
        pointer.y = clamp((local.y - 50) / 110, -1, 1);
        pointer.inside = true;
        wake();
      };
      const mark = root.querySelector(".sgf-mark") || root;
      listen(mark, "pointermove", pointerMove);
      listen(mark, "pointerenter", pointerMove);
      listen(mark, "pointerleave", () => {
        pointer.inside = false;
        wake();
      });
      const resetMotion = () => {
        stop();
        current = { x: 0, y: 0 };
        pointer.inside = false;
        paint();
        root.querySelectorAll(".is-flip, .is-o-spin").forEach((el) => el.classList.remove("is-flip", "is-o-spin"));
      };
      listen(mq, "change", () => {
        if (still()) {
          root.dataset.in = "true";
          resetMotion();
        } else wake();
      });
      listen(document, "visibilitychange", () => {
        if (document.hidden) stop();
        else wake();
      });
      if (!still() && "IntersectionObserver" in window) {
        root.dataset.in = "false";
        const io = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (visible && !seen) {
            seen = true;
            root.dataset.in = "true";
          }
          if (visible) wake();
          else resetMotion();
        }, { threshold: 0.1 });
        io.observe(root);
        cleanup.push(() => io.disconnect());
      } else {
        visible = true;
        root.dataset.in = "true";
      }
      root.querySelectorAll("[data-sgf-glyph]").forEach((glyph) => {
        const activate = () => {
          if (still()) return;
          if (glyph.hasAttribute("data-sgf-o")) {
            glyph.classList.remove("is-o-spin");
            void glyph.getBoundingClientRect();
            glyph.classList.add("is-o-spin");
            letterO.dataset.spins = String(++spins);
          } else {
            glyph.classList.remove("is-flip");
            void glyph.getBoundingClientRect();
            glyph.classList.add("is-flip");
          }
        };
        listen(glyph, "click", activate);
        listen(glyph, "keydown", (event) => {
          const e = event;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            activate();
          }
        });
        listen(glyph, "animationend", () => glyph.classList.remove("is-flip", "is-o-spin"));
      });
      root.querySelectorAll(".sgf-form").forEach((form) => {
        const field = form.querySelector(".sgf-field");
        const input = form.querySelector('input[type="email"]');
        if (input && field) {
          listen(input, "invalid", () => {
            field.dataset.state = "error";
          });
          listen(input, "input", () => {
            field.dataset.state = "idle";
          });
        }
      });
      controllers.set(root, { destroy() {
        destroyed = true;
        resetMotion();
        cleanup.forEach((fn) => fn());
        root.dataset.in = "true";
        controllers.delete(root);
      } });
      paint();
    }
    const scan = (scope) => {
      if (scope instanceof HTMLElement && scope.matches("[data-spotit-footer]")) init(scope);
      scope.querySelectorAll("[data-spotit-footer]").forEach(init);
    };
    window[key] = { scan };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => scan(document), { once: true });
    else scan(document);
    document.addEventListener("shopify:section:load", (e) => scan(e.target));
    document.addEventListener("shopify:section:unload", (e) => {
      const target = e.target;
      controllers.forEach((controller, root) => {
        if (target === root || target.contains(root)) controller.destroy();
      });
    });
  })();
})();
